import { IconProps } from '@/types/global.types';

export default function Logo({ width = '76', height = '40', className = '' }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 76 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.164062 19.3691L4.33202 19.3278L4.32413 3.6502L9.71502 7.70271C9.70975 9.89759 9.70478 12.093 9.7001 14.2889L13.8812 14.2746L13.9339 7.65668L19.0984 3.67876V19.3691H23.3392V0H16.9482L11.8056 4.0787L6.73577 0.0134909L0.164062 0V19.3691Z"
                fill="#145DA0"
            />
            <path
                d="M27.3164 19.3728H31.5493V3.80945H38.8062V8.17382H32.788L33.9346 10.1052L38.8018 19.3712H43.4013C42.1591 16.8848 40.9172 14.3985 39.6755 11.9121L43.0092 9.15937C43.0092 7.05601 43.0107 4.95239 43.0136 2.8485L39.665 0.00927734H27.3217L27.3164 19.3728Z"
                fill="#145DA0"
            />
            <path d="M0.0117188 21.8405H3.34539C3.34539 21.8405 4.07704 21.8135 4.07704 22.4483" fill="white" />
            <path
                d="M4.07067 23.0827C4.06014 23.3811 4.0619 23.6025 4.06277 23.7382C4.07155 24.5968 4.07593 25.0602 4.07418 25.5157C4.07418 25.8775 4.06979 25.9735 4.06891 26.5139C4.06891 26.8242 4.06891 26.9345 4.06891 27.1726C4.06891 27.7852 4.06102 28.2232 4.05751 28.4485C4.04172 29.646 4.0812 29.98 4.07418 31.7107C4.07418 32.3701 4.0654 32.3947 4.06277 33.1946C4.06277 34.3666 4.07242 34.3468 4.05751 34.7951C4.05751 34.8959 4.05751 35.0705 4.05225 35.418C4.05225 36.1862 4.06102 36.3885 4.1698 36.4258C4.24876 36.4536 4.34526 36.3814 4.53387 36.225C4.76723 36.0346 5.06901 35.7807 5.41642 35.468L9.68526 32.1662L9.68 26.1069H13.8032V32.0638L19.3397 36.3925C19.3248 34.9546 19.3257 33.7953 19.3283 33.0089C19.3283 32.1178 19.3371 31.7393 19.3397 30.6958C19.3397 29.4055 19.3345 28.4739 19.3318 27.9978C19.3248 26.8131 19.3196 24.9967 19.3318 22.3146C19.3405 22.2007 19.3887 22.0921 19.4696 22.0043C19.5279 21.9454 19.5993 21.8983 19.6791 21.866C19.7589 21.8338 19.8454 21.8171 19.9328 21.8171C20.0547 21.8171 20.2521 21.8171 20.4969 21.8171C20.9601 21.8171 21.1206 21.8218 21.6207 21.8234C21.9716 21.8234 21.9716 21.8234 22.3523 21.8234C22.7331 21.8234 23.0848 21.8274 23.3559 21.8306C23.3603 22.417 23.3647 23.2986 23.3673 24.3698C23.3673 25.4625 23.3673 26.2418 23.3673 26.7504C23.3673 29.2206 23.3717 29.7079 23.3673 32.4741C23.3673 33.5342 23.3673 35.1006 23.3603 37.0328C23.2322 37.1614 23.0287 37.3614 22.7664 37.5962C22.34 37.9787 22.1786 38.0779 21.49 38.6469C21.1513 38.9254 21.1715 38.9183 20.6127 39.3825C20.3047 39.6388 20.0521 39.8467 19.8845 39.984C19.4617 39.9877 19.0347 39.9898 18.6037 39.9903C18.1235 39.9903 17.6483 39.9882 17.1781 39.984L17.0465 39.88C15.292 38.4919 13.5339 37.1127 11.7723 35.7426C11.4275 36.0163 10.9038 36.4321 10.2643 36.9416C9.73088 37.3661 9.29926 37.7097 8.68516 38.2009C8.17634 38.6064 7.44206 39.1904 6.53495 39.9062H0.251865C0.186116 39.9043 0.12352 39.8803 0.0764089 39.8387C0.0396636 39.8008 0.016159 39.7538 0.00885789 39.7038C-0.00295263 39.6477 -0.00295263 39.5901 0.00885789 39.534C0.0220171 38.9714 0.0299132 38.4842 0.0334223 38.093C0.0500906 36.4782 0.0334223 36.4567 0.0334223 35.5537C0.0334223 34.98 0.0378082 34.5102 0.04044 34.2047C0.04044 34.1087 0.0316674 33.9548 0.0255264 33.7659C-0.022724 32.1471 0.0360538 31.5504 0.0255264 29.6087C0.0255264 29.1214 0.0193855 28.8604 0.0255264 28.2446C0.0255264 27.6098 0.0360536 27.2638 0.04044 26.8774C0.0518447 25.9251 0.0334219 25.5458 0.0220172 24.3635C0.0158763 23.7676 0.0106126 22.8883 0.0220172 21.7988L2.0152 21.821C2.50999 21.8028 2.92582 21.8052 3.24339 21.8123C3.61799 21.821 3.73906 21.8337 3.84784 21.9202C4.07769 22.102 4.08558 22.4757 4.0926 22.7749C4.08558 22.8693 4.07944 22.8534 4.07067 23.0827Z"
                fill="#145DA0"
            />
            <path
                d="M47.4988 17.8885C47.4988 17.8885 47.4988 17.5711 47.4988 16.3197C47.4988 15.3628 47.4988 13.5099 47.4988 12.5902C47.4988 11.4118 47.4988 9.86444 47.4988 9.7097C47.4988 7.71717 47.4988 7.50451 47.4988 6.54594C47.4988 5.91588 47.4988 5.5088 47.4988 4.63117C47.4988 4.13284 47.4988 3.63477 47.4988 3.13697C47.4988 2.71164 47.4988 2.28632 47.4988 1.86099C47.4988 1.86099 47.4988 1.39916 47.4988 1.05398V1.04525C47.4988 1.02541 47.4988 0.978592 47.4988 0.919078C47.5007 0.749402 47.5413 0.581912 47.6181 0.427096C47.7497 0.205704 48.0164 0.117621 48.1331 0.0858805H49.413C49.9061 0.0858805 50.5193 0.0858805 51.2632 0.0858805H51.4667C52.173 0.0858805 52.4318 0.0771529 53.2546 0.0795334H54.0196C54.7276 0.083501 55.2478 0.0890561 55.3601 0.0898496C55.8926 0.0946107 56.8164 0.0985783 58.5332 0.0898496C58.6987 0.120058 58.851 0.192794 58.9719 0.299338C59.1956 0.50486 59.2158 0.787354 59.243 1.23966C59.2517 1.3936 59.243 1.36266 59.2368 1.94351C59.2368 2.08555 59.2368 2.33313 59.2368 2.60928C59.2368 2.81956 59.243 3.10047 59.2526 3.43613C59.2526 3.43613 59.2526 3.44882 59.2526 3.45993C59.2526 3.47104 59.2333 3.74481 59.2044 4.06063L63.6171 8.19408C63.6223 5.73205 63.6279 3.26949 63.6337 0.806399C63.6892 0.601402 63.814 0.417185 63.9908 0.2795C64.0909 0.202409 64.2073 0.144624 64.3329 0.109688C64.4401 0.0805622 64.552 0.0687428 64.6637 0.0747725H65.0058H65.8173L68.0017 0.0795334H70.5967L74.6322 0.0842944C74.8077 0.146189 75.1428 0.293785 75.3016 0.606433C75.3681 0.727958 75.3983 0.863082 75.3893 0.99843C75.3893 1.20871 75.3805 1.5539 75.3805 1.99113C75.3805 2.36408 75.3849 2.62118 75.3867 2.78465C75.4025 4.17013 75.3595 4.75813 75.3867 6.23329C75.3867 6.39834 75.3867 6.42294 75.3919 6.56498C75.4016 7.29661 75.3919 7.74257 75.3919 8.32263C75.3919 8.75669 75.3919 8.83445 75.3919 9.55894C75.3919 11.0436 75.384 11.2864 75.3805 13.3782C75.3805 14.6692 75.3805 15.0858 75.3805 15.5278C75.3858 16.0991 75.3911 16.4086 75.3919 16.9918C75.3919 17.6973 75.3919 18.2726 75.384 18.6479C75.3859 18.774 75.3581 18.8991 75.3026 19.0148C75.2471 19.1305 75.1651 19.2343 75.0621 19.3192C74.8773 19.4613 74.6403 19.5352 74.398 19.5264H74.1857H73.6698C72.6285 19.5264 71.7802 19.5264 71.2064 19.5264H68.1263C67.1008 19.5264 66.6621 19.5264 65.9735 19.5264C65.2848 19.5264 64.6979 19.5311 64.3066 19.5343C64.1435 19.4727 63.9991 19.3767 63.8855 19.2542C63.6223 18.9669 63.6294 18.6075 63.632 18.4249C63.6443 17.5703 63.6153 16.7157 63.632 15.8619C63.6373 15.6167 63.639 15.2271 63.6171 14.7462C63.5101 14.6454 63.3407 14.4875 63.1337 14.2955C62.2924 13.5154 61.3879 12.6799 60.2299 11.734C60.0001 11.5459 59.6641 11.2753 59.2473 10.9539C59.2438 12.4601 59.24 13.9659 59.2359 15.4715C59.2544 17.6465 59.2552 18.4416 59.2473 18.5384C59.2473 18.544 59.2474 18.5908 59.2403 18.6543C59.2333 18.7725 59.2342 18.855 59.2333 18.8733C59.2177 18.989 59.1746 19.1003 59.1069 19.1995C59.0392 19.2986 58.9486 19.3834 58.8412 19.4478C58.7002 19.5237 58.5374 19.5599 58.3736 19.5517C57.4331 19.5287 48.1155 19.5517 48.1155 19.5517C47.9579 19.514 47.8164 19.4344 47.7094 19.3232C47.5585 19.1597 47.5339 18.9685 47.5049 18.6773C47.4909 18.5503 47.49 18.4392 47.4883 18.2075C47.4988 18.0726 47.4988 17.9639 47.4988 17.8885Z"
                fill="#145DA0"
            />
            <path
                d="M43.0335 39.9939L47.0479 39.9614C47.0555 35.169 47.0593 30.3759 47.0593 25.582H54.2583L54.253 29.0433H48.3086C48.4946 29.3877 48.6803 29.7316 48.8657 30.0749L54.1214 39.9725L58.6394 39.9939L55.0031 32.7284C55.7377 32.1253 56.4755 31.5085 57.2165 30.8779C57.592 30.5605 57.963 30.2431 58.3297 29.9257C58.3455 29.2718 58.3578 28.6132 58.3666 27.9498C58.3812 26.8347 58.385 25.7341 58.378 24.648L54.9434 21.835C52.3871 21.8397 49.8312 21.8397 47.276 21.835C45.8601 21.835 44.4439 21.8328 43.0273 21.8286L43.0335 39.9939Z"
                fill="#145DA0"
            />
            <path
                d="M75.4922 25.547C75.487 24.3091 75.482 23.0715 75.4773 21.8341C73.1823 21.8293 71.3892 21.8238 70.1443 21.819C69.2021 21.8151 67.4247 21.8055 65.0429 21.8238L64.3771 21.8293L60.9609 24.6067C60.9797 28.7578 60.9978 32.9088 61.0153 37.0594L64.5613 39.9954L75.5589 40.0002C75.5589 38.7306 75.5565 37.4609 75.5519 36.1913C73.9236 36.1913 72.296 36.1913 70.6689 36.1913C68.7933 36.1881 66.918 36.1818 65.0429 36.1722L65.0543 32.7942C65.0596 31.1207 65.0263 30.4033 65.0245 28.8766C65.0245 27.534 65.0377 26.4032 65.0535 25.5676C67.2671 25.5607 69.4811 25.5552 71.6953 25.551C72.913 25.5518 74.2746 25.5518 75.4922 25.547Z"
                fill="#145DA0"
            />
            <path
                d="M31.525 32.773V28.9641H36.8036C36.7989 28.461 36.7963 27.9545 36.7957 27.4445C36.7957 26.8049 36.7983 26.1701 36.8036 25.54H29.6827C29.6926 29.1035 29.6982 32.6677 29.6994 36.2327V39.994H25.5647C25.5647 34.8986 25.5627 29.8031 25.5586 24.7076L28.9861 21.8391L37.4808 21.8271L40.9171 24.6203C40.9171 25.298 40.9171 26.328 40.9119 27.5833C40.9119 30.1377 40.9119 31.7017 40.9171 33.2658C40.9224 34.8298 40.9171 37.1326 40.9057 39.9964H36.7659L36.8106 32.7817L31.525 32.773Z"
                fill="#145DA0"
            />
            <path d="M66.8867 28.9678V32.7727H75.4841V28.971L66.8867 28.9678Z" fill="#145DA0" />
            <path
                d="M50.7656 1.93799H52.7588L54.9994 4.20746H55.4915L68.0796 16.019H68.6621L70.3202 17.4981H72.2906"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M51.9307 5.36182H55.1336L59.0086 9.00884H54.8423L51.9307 11.7235H50.7656"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M66.3085 2.99148V7.28602L64.0021 9.53486L56.4531 2.62646"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M67.2963 4.0249V7.50925L65.4146 9.53511H64.0039"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M68.5047 3.84229V7.69166L66.5563 9.53501H65.4141"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M70.5212 8.2998L68.5053 10.3058H63.5776L55.582 3.05225"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M72.0227 9.1709H71.0595L68.9987 11.1364H64.25L67.2968 14.0336H70.8805"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M71.506 12.1088H69.6471L68.9742 12.7166H67.2951L65.6484 11.1367"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M67.5187 16.8094L59.8135 9.81055H55.4684L53.4296 11.6023V12.7164L51.9961 14.0337"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M50.3633 17.2141L51.2809 16.3635V14.9248"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M54.3945 15.8363L54.484 11.9258L55.9175 10.6094"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path d="M55.582 15.4715V12.23L58.3367 9.81055" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
            <path
                d="M56.4531 16.3833V12.4934L59.4096 9.81055"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M67.7891 9.71761L69.5366 8.07661V7.04345L71.0596 5.68652"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M71.6641 4.51122V3.33601L72.6721 2.38379"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M49.8915 2.5007C50.235 2.5007 50.5135 2.24881 50.5135 1.9381C50.5135 1.62738 50.235 1.37549 49.8915 1.37549C49.548 1.37549 49.2695 1.62738 49.2695 1.9381C49.2695 2.24881 49.548 2.5007 49.8915 2.5007Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M51.3876 5.92502C51.7311 5.92502 52.0096 5.67313 52.0096 5.36241C52.0096 5.05169 51.7311 4.7998 51.3876 4.7998C51.0441 4.7998 50.7656 5.05169 50.7656 5.36241C50.7656 5.67313 51.0441 5.92502 51.3876 5.92502Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M50.2353 12.2863C50.5788 12.2863 50.8573 12.0345 50.8573 11.7237C50.8573 11.413 50.5788 11.1611 50.2353 11.1611C49.8918 11.1611 49.6133 11.413 49.6133 11.7237C49.6133 12.0345 49.8918 12.2863 50.2353 12.2863Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M51.4657 14.884C51.8093 14.884 52.0877 14.6321 52.0877 14.3214C52.0877 14.0107 51.8093 13.7588 51.4657 13.7588C51.1222 13.7588 50.8438 14.0107 50.8438 14.3214C50.8438 14.6321 51.1222 14.884 51.4657 14.884Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M49.9736 18.1501C50.3171 18.1501 50.5955 17.8982 50.5955 17.5875C50.5955 17.2768 50.3171 17.0249 49.9736 17.0249C49.63 17.0249 49.3516 17.2768 49.3516 17.5875C49.3516 17.8982 49.63 18.1501 49.9736 18.1501Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M54.5321 16.9455C54.8757 16.9455 55.1541 16.6936 55.1541 16.3829C55.1541 16.0722 54.8757 15.8203 54.5321 15.8203C54.1886 15.8203 53.9102 16.0722 53.9102 16.3829C53.9102 16.6936 54.1886 16.9455 54.5321 16.9455Z"
                stroke="white"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M56.454 17.5085C56.7975 17.5085 57.076 17.2566 57.076 16.9459C57.076 16.6352 56.7975 16.3833 56.454 16.3833C56.1105 16.3833 55.832 16.6352 55.832 16.9459C55.832 17.2566 56.1105 17.5085 56.454 17.5085Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M67.915 17.7766C68.2585 17.7766 68.537 17.5247 68.537 17.214C68.537 16.9033 68.2585 16.6514 67.915 16.6514C67.5714 16.6514 67.293 16.9033 67.293 17.214C67.293 17.5247 67.5714 17.7766 67.915 17.7766Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M72.9111 18.1501C73.2546 18.1501 73.533 17.8982 73.533 17.5875C73.533 17.2768 73.2546 17.0249 72.9111 17.0249C72.5675 17.0249 72.2891 17.2768 72.2891 17.5875C72.2891 17.8982 72.5675 18.1501 72.9111 18.1501Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M71.5087 14.5964C71.8522 14.5964 72.1307 14.3445 72.1307 14.0338C72.1307 13.7231 71.8522 13.4712 71.5087 13.4712C71.1652 13.4712 70.8867 13.7231 70.8867 14.0338C70.8867 14.3445 71.1652 14.5964 71.5087 14.5964Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M72.1259 12.6242C72.4694 12.6242 72.7479 12.3723 72.7479 12.0616C72.7479 11.7509 72.4694 11.499 72.1259 11.499C71.7824 11.499 71.5039 11.7509 71.5039 12.0616C71.5039 12.3723 71.7824 12.6242 72.1259 12.6242Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M72.6415 9.81125C72.985 9.81125 73.2635 9.55936 73.2635 9.24864C73.2635 8.93792 72.985 8.68604 72.6415 8.68604C72.298 8.68604 72.0195 8.93792 72.0195 9.24864C72.0195 9.55936 72.298 9.81125 72.6415 9.81125Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M71.5439 5.77609C71.8874 5.77609 72.1659 5.5242 72.1659 5.21349C72.1659 4.90277 71.8874 4.65088 71.5439 4.65088C71.2004 4.65088 70.9219 4.90277 70.9219 5.21349C70.9219 5.5242 71.2004 5.77609 71.5439 5.77609Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M73.0595 2.60031C73.403 2.60031 73.6815 2.34842 73.6815 2.0377C73.6815 1.72698 73.403 1.4751 73.0595 1.4751C72.716 1.4751 72.4375 1.72698 72.4375 2.0377C72.4375 2.34842 72.716 2.60031 73.0595 2.60031Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M68.5048 3.84347C68.8483 3.84347 69.1268 3.59159 69.1268 3.28087C69.1268 2.97015 68.8483 2.71826 68.5048 2.71826C68.1613 2.71826 67.8828 2.97015 67.8828 3.28087C67.8828 3.59159 68.1613 3.84347 68.5048 3.84347Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
            <path
                d="M66.3095 3.0632C66.653 3.0632 66.9315 2.81131 66.9315 2.50059C66.9315 2.18988 66.653 1.93799 66.3095 1.93799C65.966 1.93799 65.6875 2.18988 65.6875 2.50059C65.6875 2.81131 65.966 3.0632 66.3095 3.0632Z"
                stroke="white"
                strokeWidth="0.75"
                strokeMiterlimit="10"
            />
        </svg>
    );
}
